import { TYPES } from '../../common/constants';

export const setCommonAreaAssetFormData = payload => ({
  type: TYPES.SET_COMMON_AREA_ASSET_FORM_DATA,
  payload,
});

export const clearCommonAreaAssetFormData = () => ({
    type:TYPES.CLEAR_COMMON_AREA_ASSET_FORM_DATA,
})